<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
        <div class="content">
            <div class="content-header">
                <Backbutton />
                Группа экспертов оценки
            </div>
            <table>
                <tr>
                    <th>Фамилия</th>
                    <th>Имя</th>
                    <th>Отчество</th>
                    <th></th>
                    <th></th>
                </tr>
                <tr v-for="expert in experts" :key="expert.id">
                    <td>{{ expert.surname }}</td>
                    <td>{{ expert.name }}</td>
                    <td>{{ expert.third_name }}</td>
                    <td>
                        <button @click="send_invite(expert.id)">Отправить приглашение</button>
                    </td>
                    <td>
                        <Btn_delete @click="delete_expert(expert.expertgroup_id)" />
                    </td>
                </tr>
            </table>
            <br><br>
            <hr />            
            <div class="header-for-input">Добавить пользователя</div><br>
            <input 
                class="content-input input_width_50" 
                style="width: 400px !important;" 
                type="text" v-model="user_search_pole.search" 
                placeholder="Начните ввод, чтобы добавить эксперта"
                @keyup="search()"
                 />
            <table>
                <tr v-for="resault in resaults" :key="resault.id">
                    <td>{{ resault.surname }}</td>
                    <td>{{ resault.name }}</td>
                    <td>{{ resault.third_name }}</td>
                    <td>
                        <button @click="add_expert_in_group(resault.id)">Добавить</button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>


<script>

import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'
import Btn_delete from '@/components/elements/svg/btn_delete.vue'
import Backbutton from '@/components/elements/bacl-button.vue'

export default {
    name: 'Kcop',
    components: {
        Success, Error, Btn_delete, Backbutton
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            experts: {},
            resaults: {},
            user_search_pole: {
                search: ''
            }
        }
    },
    methods: {
        send_invite(expert_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/admin/expert_send_welcome/'+expert_id)
                .then(response => {
                    console.log(response.data.data)
                    //this.get_experts_group()
                    loader.hide();
                    this.isSuccess = true
                    this.operation_info = response.data.data

                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        delete_expert(expert_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.delete(process.env.VUE_APP_API_URL + '/api/admin/expertsgroup/'+expert_id)
                .then(response => {
                    console.log(response.data.data)
                    this.get_experts_group()
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        add_expert_in_group(user_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/admin/expertsgroup', {
                expert_id: user_id
            })
                .then(response => {
                    console.log(response.data.data)
                    this.get_experts_group()
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        get_experts_group() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/admin/expertsgroup')
                .then(response => {
                    this.experts = response.data.data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        },
        search() {
            if(this.user_search_pole.search.length < 3) {
                this.resaults = {}
                return 0
            }
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/admin/users/search', this.user_search_pole)
                .then(response => {
                    this.resaults = response.data.data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        }
    },
    created() {
        this.get_experts_group()
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>